// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2JhT8","log":"ModalInventoryLogs_log__DPwFa","date":"ModalInventoryLogs_date__2PbY6","userName":"ModalInventoryLogs_userName__2_TOA"};